import { api } from './api';

export type ConnectorKind =
  | 'salesforce'
  | 'hubspot'
  | 'pipedrive'
  | 'gmail'
  | 'm365'
  | 'linkedin_csv'
  | 'sansan_csv';

export interface ConnectorDescriptor {
  kind: ConnectorKind;
  label: string;
  region: 'JP' | 'global';
  partnerUrl: string;
}

export interface ConnectorInstall {
  id: string;
  provider: string;
  displayName: string | null;
  status: string;
  lastSyncedAt: string | null;
  createdAt: string;
}

export const connectorsApi = {
  async list(): Promise<ConnectorDescriptor[]> {
    const r = await api.get<ConnectorDescriptor[]>('/api/connectors');
    return r.data;
  },
  async listInstalls(workspaceId: string): Promise<ConnectorInstall[]> {
    const r = await api.get<ConnectorInstall[]>('/api/connectors/installs', {
      params: { workspaceId },
    });
    return r.data;
  },
  startUrl(kind: ConnectorKind, workspaceId: string): string {
    const base = (import.meta.env.VITE_API_URL as string | undefined) || '';
    return `${base}/api/connectors/${kind}/oauth/start?workspaceId=${encodeURIComponent(workspaceId)}`;
  },
  async disconnect(installId: string): Promise<void> {
    await api.delete(`/api/connectors/installs/${installId}`);
  },
};
